import React from 'react';
import { useOutletContext } from 'react-router-dom';
import VenuesTab from '../organization/venue-booking/VenuesTab';

export default function VenueOwnerVenuesPage() {
  const { venues, reloadVenues } = useOutletContext();
  return (
    <div data-testid="venue-owner-venues-page">
      <VenuesTab venues={venues} onReload={reloadVenues} canManage />
    </div>
  );
}
